import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-3395">
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-3396">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-3397" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-3398" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-3399">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-3400">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-3401" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-3402" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-3403" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-3404">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-3405">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-3406" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-3407" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-3408">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-3409">
            <thead data-id="element-3410">
              <tr data-id="element-3411">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-3412">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-3413" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3414">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-3415">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-3416">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-3417" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-3418">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-3419" />
          <div className="flex gap-2" data-id="element-3420">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-3421" />)}
          </div>
        </div>
      </div>
    </div>;
}